<template>
    <div class="containter m-5 grid">
      <card  class=" col-10   surface-50">
        <template #title>
            <span class="text-700">---- COMPROBANTE.... PDF Download??? ----</span>        
        </template>
        <template #content>
             

        </template>
        <template #footer>
          <div class="flex justify-content-around flex-wrap w-full ">
            <div class="flex align-items-center justify-content-center col-4">
              <Button icon="pi pi-backward" label="Volver a Empezar" class="p-button-info " @click="goHome" />
            </div>
            
          </div>
        </template>
    </card>
  </div>
 </template>
 
<script>
 import { ref } from '@vue/reactivity';
export default {
    setup(props,{ emit }) {
     

   // expose to template and other options API hooks
   return {
     emit
   }
 },
 methods: {
    comprobante() {
    this.emit("currentStep",4)
  },
  goHome() {
    this.emit("currentStep",1)
  }
 },
 mounted() {
   console.log("@Mounted Edo de Cuenta")
 }
}
</script>
<style lang="scss">

 </style>